var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackgroundArc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 883,
    height: 768,
    viewBox: "0 0 883 768",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 768V0H851C851 0 557.277 190.39 550.323 379.488C543.754 558.144 791.965 768 791.965 768H0Z",
    fill: "url(#paint0_radial_249_364)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M791.965 768H823.965C823.965 768 575.754 558.144 582.323 379.488C589.277 190.39 883 0 883 0H851C851 0 557.277 190.39 550.323 379.488C543.754 558.144 791.965 768 791.965 768Z",
    fill: "url(#paint1_radial_249_364)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_249_364",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(441.5 384) rotate(90) scale(384 441.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCEBF6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_249_364",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(457.5 384) rotate(90) scale(384 425.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BAED6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundArc);
export default __webpack_public_path__ + "static/media/background_arc.da8941e5505a8bba4c4a0ece64dcf5bd.svg";
export { ForwardRef as ReactComponent };